/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  HeaderTitle,
  IconButton,
  LoaderWrapper,
  StyledContainer,
  TableCell,
  TableWrapper,
} from '../../../services/settings/appStyle/global.style';
import {
  DeleteConfirmationModal,
  DropdownButton,
  Loader,
  Switch,
  Table,
} from '../../../Components/uielements';
import { useUserContext } from '../../../hooks/UserContext';
import Company, {
  adminCompaniesForReport,
  suspendCompany,
} from '../../../services/bioplus-services/company';
import {
  DeleteIcon,
  //  EditIcon, EyeIcon, ViewIcon
} from '../../../Components/icons';
import { useCompany } from '../../../hooks/CompanyContext';
import { CompanyContainer } from './company.style';
import {
  AccessControlModal,
  EditCompanyModal,
  ViewCompanyDetailsModal,
  ViewUserDetailsModal,
} from './modals';
import { IntlMessages } from '../../../helper/langHelper';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import { exportExcelFile } from '../../../helper/exportExcelHelper';
import moment from 'moment';
import Spinner from '../../../Components/uielements/loader/spinner';
import { userDeletion } from '../../../services/bioplus-services/user';

export function extractData(dataArray) {
  if (dataArray) {
    const extractedData = dataArray?.map((item) => {
      return {
        companyName: item?.name,
        ownerFirstName: item?.userId?.firstName ?? '--',
        ownerLastName: item?.userId?.lastName ?? '--',
        ownerEmail: item?.userId?.email ?? '--',
        ownerPhone: item?.userId?.phone ?? '--',
        addressState: item?.userId?.addressState ?? '--',
        addressTown: item?.userId?.addressTown ?? '--',
        addressStreet: item?.userId?.addressStreet ?? '--',
        zipCode: item?.userId?.zipCode ?? '--',
        createdAt: moment(item?.createdAt).format('DD-MM-YYYY'),
      };
    });
    return { bioplusUsers: extractedData };
  }
}

const AdminCompanies = () => {
  const [editCompany, setEditCompany] = useState(undefined);
  const [isAccessControlEdit, setIsAccessControlEdit] = useState();
  const [viewCompanyRelatedUser, setViewCompanyRelatedUser] = useState();
  const [viewCompany, setViewCompany] = useState();
  const [deleteCompany, setDeleteCompany] = useState();
  const [loadingCompanyId, setLoadingCompanyId] = useState(null);
  const userContext = useUserContext();
  const companyContext = useCompany();
  const companyFilter = companyContext?.company?._id;
  const partnerId = userContext.company?.partnerId;

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [name, setName] = useState();

  const queryClient = useQueryClient();

  const usersQuery = useQuery(['adminCompanies', companyFilter, name, page, pageSize], () =>
    Company.adminCompanies(companyFilter, name, page, pageSize)
  );

  const allCompanies = useQuery(['allCompanies'], () => adminCompaniesForReport());

  const userTableData = usersQuery?.data?.data ?? [];

  const handleNextPage = () => {
    setPage((value) => value + 1);
  };
  const handlePreviousPage = () => {
    setPage((value) => value - 1);
  };

  const userColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="label.company.name" />,
        accessor: 'name',
        width: '20%',
      },
      {
        Header: <IntlMessages id="company.module.company.owner.details" />,
        accessor: 'userId.addressTown',
        width: '32%',
        Cell: (cellData) => (
          <TableCell>
            {`${cellData?.row?.original?.userId?.firstName ?? '--'} ${
              cellData?.row?.original?.userId?.lastName ?? '--'
            }, ${cellData?.row?.original?.userId?.email ?? '--'}, ${
              cellData?.row?.original?.userId?.phone ?? '--'
            }` ?? '--'}
          </TableCell>
        ),
      },
      {
        Header: <IntlMessages id="input.label.address" />,
        accessor: 'userId.addressCountry',
        width: '24%',
        Cell: (cellData) => (
          <TableCell>
            {`${cellData?.row?.original?.userId?.addressStreet ?? '--'}, ${
              cellData?.row?.original?.userId?.addressTown ?? '--'
            }, ${cellData?.row?.original?.userId?.addressState ?? '--'}, ${
              cellData?.row?.original?.userId?.zipCode ?? '--'
            }` ?? '--'}
          </TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.createdAt" />,
        accessor: 'createdAt',
        width: '12%',
        Cell: (cellData) => (
          <TableCell>
            {cellData.value ? moment(cellData.value).format('DD-MM-YYYY') : '--'}
          </TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.actions" />,
        accessor: 'actions',
        isAction: true,
        width: '20%',
      },
    ],
    []
  );

  const handleClosedEdit = () => {
    setEditCompany(undefined);
  };
  const handleClosedViewCompany = () => {
    setViewCompany(undefined);
  };
  const handleClosedViewCompanyUser = () => {
    setViewCompanyRelatedUser(undefined);
  };
  const handleClosedAccessControl = () => {
    setIsAccessControlEdit(undefined);
  };
  const handleClosedDeleteCompany = () => {
    setDeleteCompany(undefined);
  };

  const suspendCompanyMutation = useMutation(({ companyId }) => suspendCompany({ companyId }), {
    onSuccess: () => {
      queryClient.invalidateQueries(['adminCompanies']);
    },
    onError: (error) => {
      alert(error?.response?.data?.message || 'Failed to suspend company status');
    },
    onSettled: () => {
      setLoadingCompanyId(null);
    },
  });

  const deleteMutation = useMutation((data) => userDeletion(data?.userId?._id), {
    onSuccess: async () => {
      alert('Member Account Deleted Successfully!');
      await queryClient.invalidateQueries('adminCompanies');
    },
    onError: (error) => {
      alert(error?.message || 'Account Deletion in Progress!');
    },
  });

  const handleSuspendCompany = (companyId) => {
    setLoadingCompanyId(companyId);
    suspendCompanyMutation.mutate({ companyId });
  };

  const handleDeleteUser = (data) => {
    deleteMutation.mutate(data);
    setDeleteCompany(undefined);
  };

  const actionList = [
    // (data) => (
    //   <IconButton onClick={() => setEditCompany(data)}>
    //     <EditIcon style={{ width: '18px', height: '18px' }} />
    //   </IconButton>
    // ),
    // (data) => (
    //   <IconButton onClick={() => setViewCompany(data)}>
    //     <EyeIcon style={{ width: '22px', height: '22px' }} />
    //   </IconButton>
    // ),
    // (data) => (
    //   <IconButton onClick={() => setViewCompanyRelatedUser(data)}>
    //     <ViewIcon style={{ width: '20px', height: '20px' }} />
    //   </IconButton>
    // ),
    (data) => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
          width: '100%',
        }}
      >
        <IconButton
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
          }}
        >
          {suspendCompanyMutation.isLoading && loadingCompanyId === data?._id ? (
            <>
              <Spinner size={'small'} />
            </>
          ) : (
            <Switch
              handleToggle={() => handleSuspendCompany(data?._id)}
              checked={data?.suspension}
            />
          )}
        </IconButton>

        <IconButton
          onClick={() => setDeleteCompany(data)}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
          }}
        >
          <DeleteIcon
            style={{
              width: '20px',
              height: '20px',
            }}
          />
        </IconButton>
      </div>
    ),
  ];

  const excelFormatData = extractData(allCompanies?.data);
  const fileName = `Account-managers-${moment().format('DD-MM-YYYY-hh.mm A')}.xlsx`;
  const fileNameCsv = `Account-managers-${moment().format('DD-MM-YYYY-hh.mm A')}.csv`;

  const columnConfig = [
    { header: 'Entity Name', key: 'companyName', width: 20 },
    { header: 'Owner First Name', key: 'ownerFirstName', width: 15 },
    { header: 'Owner Last Name', key: 'ownerLastName', width: 15 },
    { header: 'Owner Email', key: 'ownerEmail', width: 25 },
    { header: 'Owner Phone', key: 'ownerPhone', width: 18 },
    { header: 'Street', key: 'addressStreet', width: 20 },
    { header: 'Town', key: 'addressTown', width: 15 },
    { header: 'State', key: 'addressState', width: 15 },
    { header: 'Zip Code', key: 'zipCode', width: 12 },
    { header: 'Created Date', key: 'createdAt', width: 15 },
  ];

  const handleClickItem = (item) => {
    switch (item?.key) {
      case 'excel':
        exportExcelFile(excelFormatData, fileName, columnConfig);
        break;
      case 'pdf':
        break;
      case 'csv':
        exportExcelFile(excelFormatData, fileNameCsv, columnConfig);
        break;
      default:
        break;
    }
  };

  if (usersQuery.isLoading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }

  return (
    <StyledContainer>
      <CompanyContainer>
        <HeaderTitle>
          <IntlMessages id="account.managers" />
        </HeaderTitle>
        {excelFormatData && (
          <DropdownButton
            noOfColoumns={1}
            buttonArray={[
              { key: 'excel', title: 'Export as Excel', icon: <CloudDownloadIcon /> },
              { key: 'csv', title: 'Export as CSV', icon: <SimCardDownloadIcon /> },
            ]}
            onClick={handleClickItem}
          />
        )}
      </CompanyContainer>
      <TableWrapper>
        <Table
          data={userTableData}
          columns={userColumns}
          hasFooter={true}
          actions={actionList}
          page={page}
          pageSize={pageSize}
          prevPage={handlePreviousPage}
          nextPage={handleNextPage}
          total={usersQuery?.data?.total || 0}
        />
      </TableWrapper>
      {editCompany && editCompany !== undefined && (
        <EditCompanyModal onClose={handleClosedEdit} data={editCompany} />
      )}
      {viewCompany && viewCompany !== undefined && (
        <ViewCompanyDetailsModal onClose={handleClosedViewCompany} data={viewCompany} />
      )}
      {viewCompanyRelatedUser && viewCompanyRelatedUser !== undefined && (
        <ViewUserDetailsModal onClose={handleClosedViewCompanyUser} data={viewCompanyRelatedUser} />
      )}
      {isAccessControlEdit && isAccessControlEdit !== undefined && (
        <AccessControlModal onClose={handleClosedAccessControl} data={isAccessControlEdit} />
      )}
      {deleteCompany && deleteCompany !== undefined && (
        <DeleteConfirmationModal
          onClose={handleClosedDeleteCompany}
          message={
            <IntlMessages
              id="delete.comfirmation.text.company"
              values={{
                company: ` ${deleteCompany?.name}`,
              }}
            />
          }
          onConfirm={() => handleDeleteUser(deleteCompany)}
          isLoading={deleteMutation.isLoading}
        />
      )}
    </StyledContainer>
  );
};

export default AdminCompanies;
